var LoggingResultType = {
  DEFER: 'DEFER',
  FAILURE: 'FAILURE',
  SUCCESS: 'SUCCESS'
};
Object.freeze(LoggingResultType);
export default LoggingResultType;